(function () {
  var balanceEl    = document.getElementById('js-loyalty-balance');
  var percentEl    = document.getElementById('js-loyalty-percent');
  var historyEl    = document.getElementById('js-loyalty-history');

  function formatMoney(kopiiky) {
    return '₴' + (kopiiky / 100).toFixed(2);
  }

  function typeLabel(type) {
    return type === 'earn' ? '+ Нараховано' : '− Списано';
  }

  function renderHistory(history) {
    if (!history.length) {
      historyEl.innerHTML = '<p class="profile-empty">Транзакцій поки немає</p>';
      return;
    }
    var rows = history.map(function (e) {
      var amountAbs = Math.abs(e.amount);
      var sign = e.type === 'earn' ? '+' : '−';
      var cls = e.type === 'earn' ? 'loyalty-history__amount--earn' : 'loyalty-history__amount--spend';
      return '<div class="loyalty-history__row">'
        + '<div class="loyalty-history__meta">'
        + '<span class="loyalty-history__order">' + (e.orderName || '—') + '</span>'
        + '<span class="loyalty-history__date">' + (e.date || '') + '</span>'
        + '</div>'
        + '<span class="loyalty-history__amount ' + cls + '">' + sign + formatMoney(amountAbs) + '</span>'
        + '</div>';
    });
    historyEl.innerHTML = rows.join('');
  }

  // apiFetch handles token refresh and 401 → login.
  window.SKAuth.apiFetch('/api/customer/loyalty')
    .then(function (data) {
      if (balanceEl) balanceEl.textContent = data.balanceFormatted || '₴0.00';
      if (percentEl) percentEl.textContent = (data.cashbackPercent || 3) + '%';
      if (historyEl) renderHistory(data.history || []);
    })
    .catch(function () {
      if (historyEl) historyEl.innerHTML = '<p class="profile-empty profile-msg--error">Помилка завантаження</p>';
    });
})();
